const shortcut = {
  w: 'where', o: 'order', l: 'limit'
};

const r = Object.entries(shortcut).reduce((o, [k, v]) => {
  return {...o, [k]: [k, v].join('|')};
}, {});

module.exports = {

  // where.cq.r
  r: {...r,
    all: Object.values(r).join('|'),
    key: Object.entries(shortcut).reduce((o, [k, v]) => {
      return {...o, [k]: v, [v]: v};
    }, {})
  },

  // where.cq.stringify
  stringify: (object) => {
    const join = (object, separator) => {

      return Object.entries(object).map(([k, v]) => {
        return [k, String(v)].join(',');
      }).join(separator);

    };

    // where, order, limit
    return Object.entries(object).map(([k, v]) => {
      const values = (v.or) ? v.or.map(v => join(v, ':')).join('|') : join(v, ':');
      return [k, values].join('/');
    }).join('/');

  },

  // where.cq.parse
  parse: (string) => {

    const split = (string) => {

      const re = /^['"]|['"]$/g;

      return string.split(/([^:]*["'].*?["'][^:]*)|:/).filter(v => v).reduce((o, v) => {

        const [k, ...values] = v.split(/([^,]*["'].*?["'][^,]*)|,/).filter(v => v).map((v) => {
          return (re.test(v)) ? v.replace(re, '') : (!isNaN(v)) ? Number(v) : v;
        });

        return {...o, [k]: (values.length === 1) ? values[0] : values};

      }, {});

    };

    return Object.entries(string).reduce((o, [k, v]) => {

      const [first, ...or] = v.split(/([^\|]*["'].*?["'][^\|]*)|\|/).filter(v => v),
            values = (or.length > 0) ? {or: [first, ...or].map(v => split(v))} : split(first);

      return {...o, [k]: values};

    }, {});
  }


};
